import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ISalonDetailsApi } from '@app/salon-details/models/salon-details-api.model';
import { ReviewsPaginationDefaults } from '@app/salon-details/salon-reviews/pagination-defaults';
import { ISalonReviews } from '@app/shared/models/salon-reviews.model';
import { SalonService } from '@app/shared/services/salon/salon.service';
import { tap } from 'rxjs';

@Component({
  selector: 'app-salon-reviews',
  templateUrl: './salon-reviews.component.html',
  styleUrls: ['./salon-reviews.component.scss']
})
export class SalonReviewsComponent implements OnInit {
  @Input() salonDetails: ISalonDetailsApi;
  @Input() salonReviews: ISalonReviews;
  @Output() salonReviewsChange = new EventEmitter<ISalonReviews>();
  canBeLoadedMore: boolean;

  constructor(private salonService: SalonService) { }

  ngOnInit(): void {
    this.checkCanBeLoadedMore();
  }

  loadMoreReviews(): void {
    if (!this.canBeLoadedMore) { return }

    this.salonService.getSalonReviews$(
      this.salonDetails.id,
      ReviewsPaginationDefaults.reviewsPageSize,
      this.salonReviews.pageNumber + 1)
      .pipe(
        tap((incomingReviews: ISalonReviews) => {
          const updatedReviews: ISalonReviews = {
            ...incomingReviews,
            reviews: [...this.salonReviews.reviews, ...incomingReviews.reviews]
          };
          this.salonReviews = updatedReviews;
          this.salonReviewsChange.emit(updatedReviews);
          this.checkCanBeLoadedMore();
        }))
      .subscribe();
  }

  private checkCanBeLoadedMore(): void {
    this.canBeLoadedMore = this.salonReviews.pageNumber < this.salonReviews.totalPages;
  }
}
